import { COLLAPSE_SIDEBAR } from "redux/types";

export const collapse = () => (dispatch) => {
  dispatch({ type: COLLAPSE_SIDEBAR, payload: null });
};
